import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { List, Text, Column, Row } from '@oliasoft-open-source/react-ui-library';
import { useParams } from 'react-router';
import translations from 'src/internationalisation/translation-map.json';
import { addInitialCurrencyTemplate, currencyTemplateSelected } from 'store/entities/company-settings/company-settings';

const CurrencyTemplateList = ({
  isAdding,
  addInitialCurrencyTemplate,
  currencyTemplateSelected,
  currencyTemplates,
  onClickDelete,
}) => {
  const { t } = useTranslation();
  const { company } = useParams();

  const onClickItem = (id) => currencyTemplateSelected(id);

  const currencyTemplateList = currencyTemplates
    ? [...currencyTemplates]
        .sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0))
        .map((item) => ({
          currencyTemplateId: item.currencyTemplateId,
          isDefault: item.isDefault,
          name: item.name,
          active: item.active,
          actions: [
            {
              label: 'Delete',
              icon: 'delete',
            },
          ],
          details: item.isDefault ? t(translations.default) : '',
        }))
    : [];

  return (
    <div>
      <List
        list={{
          name: (
            <Column>
              <Row>
                <Text>{t(translations.currency_templates)}</Text>
              </Row>
            </Column>
          ),
          actions: [
            {
              label: 'Add',
              icon: 'add',
              onClick: () => addInitialCurrencyTemplate(company, 'USD', [], currencyTemplates),
              disabled: isAdding,
            },
          ],

          items: currencyTemplateList?.map((currencyTemplate) => {
            return {
              ...currencyTemplate,
              onClick: () => onClickItem(currencyTemplate.currencyTemplateId),
              actions:
                currencyTemplate.isDefault !== true
                  ? currencyTemplate.actions.map((action) => ({
                      ...action,
                      onClick: () => onClickDelete(currencyTemplate.currencyTemplateId),
                    }))
                  : [],
            };
          }),
        }}
      />
    </div>
  );
};

const mapDispatchToProps = {
  addInitialCurrencyTemplate,
  currencyTemplateSelected,
};

const Container = connect(null, mapDispatchToProps)(CurrencyTemplateList);

export { Container as CurrencyTemplateList };
